import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getBookFromProductVariant } from "../../product/selectors/getBookFromProductVariant.js";
import { sortDate } from "../../utils.js";
const getProductsFromItemRelation = (components, productComponentId, overriddenPrice) => {
    const relation = getComponentContentById(components, productComponentId);
    const fromProductVariants = (relation?.productVariants ?? []).map((variant) => ({
        ...getBookFromProductVariant(variant),
        overriddenPrice,
    }));
    const fromItems = (relation?.items ?? []).flatMap((item) => {
        const productItem = item;
        if (!productItem.defaultVariant?.sku) {
            return [];
        }
        const variant = {
            ...productItem.defaultVariant,
            product: {
                shape: productItem.shape,
            },
        };
        return [
            {
                ...getBookFromProductVariant(variant),
                overriddenPrice,
            },
        ];
    });
    const products = [...fromProductVariants, ...fromItems].filter((product, index, list) => list.findIndex((candidate) => candidate.sku === product.sku) === index);
    return products;
};
export const mapBookClubDispatchProducts = (subscription) => {
    const ids = CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.DISTRIBUTION_DATES;
    const distributionDates = subscription.product.components?.find(({ componentId }) => componentId === ids.ID)?.content;
    if (!distributionDates ||
        distributionDates.__typename !== "ContentChunkContent") {
        return [];
    }
    const batches = distributionDates.chunks?.map((distributionChunk) => {
        const distributionComponents = distributionChunk;
        const distributionDate = getComponentContentById(distributionChunk, ids.SEND_DATE)?.datetime;
        const batchCode = getComponentContentById(distributionChunk, ids.BATCH_CODE)?.text;
        const bookClubPieceComponent = distributionComponents.find((component) => component.componentId === ids.BOOK_CLUB_PRODUCT_PIECE);
        const bookClubPiece = bookClubPieceComponent?.content;
        const productChunks = getComponentContentById(bookClubPiece?.components, ids.PRODUCTS_CHUNK.ID)?.chunks;
        const products = (productChunks ?? []).flatMap((productChunk) => {
            const chunkComponents = productChunk;
            const overriddenPrice = getComponentContentById(productChunk, ids.PRODUCTS_CHUNK.OVERRIDDEN_PRICE)?.number;
            return getProductsFromItemRelation(chunkComponents, ids.PRODUCTS_CHUNK.PRODUCT, overriddenPrice);
        });
        return {
            batchCode: batchCode ?? undefined,
            distributionDate: distributionDate ?? undefined,
            products,
        };
    });
    return (batches ?? []).sort(({ distributionDate: a }, { distributionDate: b }) => sortDate(a, b));
};
